import { ZusTabs } from './constants';

export const getTabInfo = (integrations = []) => {
  const activeIntegrations = [];
  const inactiveIntegrations = [];

  integrations.forEach((integration) => {
    if (integration.deletedAt) {
      inactiveIntegrations.push(integration);
      return;
    }

    activeIntegrations.push(integration);
  });

  const tabInfo = {
    ACTIVE: {
      text: ZusTabs.ACTIVE.text,
      count: activeIntegrations.length,
    },
    NOT_ACTIVE: {
      text: ZusTabs.NOT_ACTIVE.text,
      count: inactiveIntegrations.length,
    },
    ALL: {
      text: ZusTabs.ALL.text,
      count: integrations.length,
    },
  };

  return {
    tabInfo,
    activeIntegrations,
    inactiveIntegrations,
    allIntegrations: integrations,
  };
};
